import React, { Component } from 'react';
import config from '../../../../../../src/data/get-settings';
import { createContainer } from '@dbk-legacy/muster/react';
import { Toast } from '@dbk/ui-notifications'
import {
  DownloadIcon,
  PortfolioIcon,
  MaturitiesIcon,
  InsightsIcon,
  ReportsIcon
} from '../../../../../../src/components/common/icons';
import { PALETTE, EBANKINGWEBLUX, RIGHT_MENU_ICON_STYLE, RM_REGION } from '../../../constants.js';
import classNames from 'classnames';
import envConfig from '../../../../../../db-env-build';

require('npm-zepto');

import { Logout, Transform, PriceandLiquidity, Download, Transactions, Portfolio, TradingPlatform, IncomeTransactionInformation } from '@dbk/com.db.dbk.ui-icons';
import NotificationAlert from '../../../../../../src/components/common/notification-alert';
import MenuIcon from '../../../../../../src/components/common/menu';
import Text from '@dbk/ui-text';
import Button from '@dbk/ui-buttons';
import BlurModal from '../../../../../../src/components/common/blur-modal';
import Search from '../../../../../../src/common/components/icons/search';
import { Gear } from '../../../../../../src/components/common/icons';
import { iconStyle } from '../../../../../../src/screens/menu-modal/menu-modal.style';
import { ROUTES, CASH_ACCOUNTS_CONSTANTS, KEY_CODE, AVQ_DOWNTIME} from '../../../../../../src/constants';
import Guid from '../../../../../../src/utils/guid';
import SkipMainContent from '../../../../../../src/components/app/skip-main-content';
import isEnterorSpaceKeyPressed from '../../../../../../src/utils/isEnterorSpaceKeyPressed';
import DbText from '../../../../../../src/assets/svgs/db-text.js';

class AppNav extends Component {
  constructor(props) {
    super(props);

    this.handleSubmit = this.handleSubmit.bind(this);
    // this.onLogout = this.onLogout.bind(this);
    this.checkEntitlment = this.checkEntitlment.bind(this);
    this.onSearch = this.onSearch.bind(this);
    this.handleLogoutNo = this.handleLogoutNo.bind(this);
    this.webNavRef = React.createRef();
    this.syncAppNavHeight = this.syncAppNavHeight.bind(this);


    this.state = {
      logoutModal: false,
      loadingFlag: false,
      rmAccessPopup: false,
      showRedirectModal: false,
      path: '',
      navigateToPage: false,
      dataLostClicked: true,
    }
  }

  componentDidMount() {
    this.syncAppNavHeight();
    if (!window.ResizeObserver) return;

    // Keep the app header below the navigation when its content wraps.
    this.navResizeObserver = new window.ResizeObserver(this.syncAppNavHeight);
    this.navResizeObserver.observe(this.webNavRef.current);
  }

  componentWillUnmount() {
    if (this.navResizeObserver) this.navResizeObserver.disconnect();
    // Restore the default layout if this navigation is removed.
    document.documentElement.style.removeProperty('--app-nav-height');
  }

  syncAppNavHeight() {
    const webNav = this.webNavRef.current;
    if (!webNav) return;

    document.documentElement.style.setProperty('--app-nav-height', `${webNav.getBoundingClientRect().bottom}px`);
  }

  checkEntitlment(path) {
    const { app, changePage, rsaChangePage, i18n: { messages } } = this.props;
    if (app.user.selectedPortfolioData.relId != null && path !== '/downloads') {
      alert(messages['app.portfolio.circularChart.selPort']);
    } else {
      rsaChangePage(path);
    }
  }

  redirectToOtherMenu = () => {
    const { hrmw: { setDataUpdate, setDeletedRow, setAddedRow } } = this.props;
    setDataUpdate(false);
    setDeletedRow(false);
    setAddedRow(false);
    this.setState({ dataLostClicked: false, showRedirectModal: false }, () => this.handleSubmit(this.state.path));
  }

  hideRedirecteModal = () => {
    this.setState({ showRedirectModal: false, dataLostClicked: true });
  }

  redirectModalContent = () => {
    const { i18n: { messages } } = this.props;
    return (
      <div className="row padding-left-17">
        <div>
          {messages['app.manageContactDetails.amendContact.warningMessage']}
        </div>
        <div className="logout-confirm-btns margin-top-10">
          <div className="column small-3 pad-bottom-0 center">
            <Button fullWidth tertiary size='large' onClick={this.redirectToOtherMenu}>
              {messages['app.common.alert.yes']}
            </Button>
          </div>
          <div className="column center small-3">
            <Button fullWidth size='large' onClick={this.hideRedirecteModal} >
              {messages['app.common.alert.no']}
            </Button>
          </div>
        </div>
      </div>
    )
  }

  async handleSubmit(path, e) {
    if(isEnterorSpaceKeyPressed(e)){
      this.setState({ path });
      const { changePage, i18n: { messages }, hrmw: { isDataUpdated }, getUserAlerts } = this.props;
      const { portfolio: { portfolioBPLimit } } = this.props;
      getUserAlerts(AVQ_DOWNTIME); // for getting avq down banner when user clicks others tab 
      const currentPath = this.props.ui.history.currentLocation.pathname;
      if ((currentPath.includes(ROUTES.PROFILE.MANAGE_CONTACT_DETAILS) || currentPath.includes(ROUTES.PROFILE.ADD_CONTACT) || currentPath.includes(ROUTES.PROFILE.AMEND_CONTACT)) && (isDataUpdated) && this.state.dataLostClicked) {
        this.setState({ showRedirectModal: true })
        return
      }
      switch (path) {
        case 'portfolios':
          this.props.auth.setAssetSelectedIndex(0);
          this.props.portfolio.genericAssets.positions.setPageOffset(0);
          this.props.ui.state.portfolio.genericAssets.resetSort();
          await this.props.getOverallMarketAsOfDate();
          changePage('/portfolios');
          break;
        case 'dashboard':
          await this.props.getOverallMarketAsOfDate();
          changePage('/dashboard');
          break;
        case 'maturities':
          // this.checkEntitlment('/maturities'); // Check-entitlement now removed to navigate in case of All portfolios and BP
          this.props.maturities.resetTo7days();
          changePage('/maturities');
          break;
        case 'reports':
          changePage('/reports');
          break;
        case 'profile':
          changePage('/profile');
          break;
        case 'downloads':
          changePage('/downloads');
          break;
        case 'insights':
          changePage('/insights');
          break;
        case 'payments':
          changePage('/payments');
          break;
        case 'dataExports':
          await this.props.getOverallMarketAsOfDate();
          changePage('/dataExports');
          break;
        case 'transactions':
          await this.props.getOverallMarketAsOfDate();
          changePage('/transactions');
          break;
        case 'trade-library':
          this.props.setInitialPathGuid(Guid())
          this.props.setInitialPath(ROUTES.TRADE.OVERVIEW)
          if (this.props.ui.history.currentLocation.pathname !== ROUTES.TRADE.LIBRARY)
            changePage(ROUTES.TRADE.LIBRARY);
          break;
        case 'search':
          changePage('/search');
          break;
        case CASH_ACCOUNTS_CONSTANTS.CASH_ACCOUNTS:
          changePage('/cashAccounts');
          break;
        case CASH_ACCOUNTS_CONSTANTS.CASH_ACCOUNT_DETAILS:
          changePage(ROUTES.CASH_ACCOUNTS.SUMMARY_CASH_ACCOUNTS_DETAILS_ROUTE);
          break;
        default:
          console.log(path);
          break;
      }
      this.setState({ dataLostClicked: true })
    }
  }

  checkActive(path) {
    const oReturn = {
      color: '',
      active: false,
    };

    const currentPath = this.props.ui.history.currentLocation.pathname;
    // const currentPath = '/ebankingweb/downloads';

    let basePath =
      `/${currentPath.split('/')[1]}/${currentPath.split('/')[2]}`;
    let comparePath = `/${config.webfolder}/${path}`;

    // if the webfolder prefix is empty
    if (config.webfolder == '') {
      comparePath = path;
      basePath = currentPath.split('/')[1];
    }
    if (basePath == comparePath) {
      oReturn.color = PALETTE.primaryActive;
      oReturn.active = true;
    } else {
      oReturn.color = PALETTE.secondaryText;
      oReturn.active = false;
    }

    return oReturn;
  }

  closeBlurModel = (e) => {
    this.setState({ logoutModal: false });
    e.stopPropagation();
  }

  componentDidUpdate() {

    if (this.state.loadingFlag === true) {
      const { auth, payments:{isMultiSigApprovalFlow,cancelTx} } = this.props;
      if (!auth.isRMUserGroup) {

        // cancel the transaction in case of approval flow multisig
        if (isMultiSigApprovalFlow){
          cancelTx();
        }
        setTimeout(() => {
          auth.onLogout("Manual logout");
        }, 1000);
      }
    }
  
  }

  handleLogoutPressCH = () => {
    // this.setState({ logoutModal: false });
    // auth.onLogout();
    const { auth: { isRMUserGroup } } = this.props;
    this.setState({ loadingFlag: true });
    if (isRMUserGroup) {
      this.props.rmAccess.rmLogout();
    }
  }

  onLogout = (e) => {
    if(isEnterorSpaceKeyPressed(e)){
      this.setState({ logoutModal: true });
      // e.preventDefault(); // for accessibility to prevent focus method trigger button click event  
    }
  }

  handleLogoutNo(e) {
    this.setState({ logoutModal: false });
    e.stopPropagation();
  }

  onSearch(e) {
    if(isEnterorSpaceKeyPressed(e)){
      const currentPath = this.props.ui.history.currentLocation.pathname;
      this.setState({ path: 'search' })
      if ((currentPath.includes(ROUTES.PROFILE.MANAGE_CONTACT_DETAILS) || currentPath.includes(ROUTES.PROFILE.ADD_CONTACT) || currentPath.includes(ROUTES.PROFILE.AMEND_CONTACT)) && this.props.hrmw.isDataUpdated && this.state.dataLostClicked) {
        this.setState({ showRedirectModal: true })
        return
      }
      const { changePage } = this.props;
      changePage('/search');
    }
  }

  onSwitchRMSession(e) {
    if(isEnterorSpaceKeyPressed(e)){
      const { changePage } = this.props;
      this.showHideRMWarningPrompt(e);
      this.props.rmAccess.rmSessionLogout();
      changePage('/rm-access/search');
    }
  }

  hideRMWarningPrompt = () => {
    this.props.rmAccess.setRMWarningPrompt(false);
  }

  showHideRMWarningPrompt = (e) => {
    if(isEnterorSpaceKeyPressed(e)){
      this.setState({ rmAccessPopup: !this.state.rmAccessPopup })
      e && e.preventDefault(); // for RM switch button accessibility to prevent focus method trigger button click event
    }
  }

  onSettingChange = (e) => {
    if(isEnterorSpaceKeyPressed(e)){
      const { getUserAlerts } = this.props;
      getUserAlerts(AVQ_DOWNTIME); // for getting avq down banner when user clicks others tab 
      const currentPath = this.props.ui.history.currentLocation.pathname;
      this.setState({ path: 'profile' })
      if ((currentPath.includes(ROUTES.PROFILE.MANAGE_CONTACT_DETAILS) || currentPath.includes(ROUTES.PROFILE.ADD_CONTACT) || currentPath.includes(ROUTES.PROFILE.AMEND_CONTACT)) && this.props.hrmw.isDataUpdated && this.state.dataLostClicked) {
        this.setState({ showRedirectModal: true })
        return
      }
      this.props.changePage('/profile');
    }
  }

  WebNav(heightValue, widthValue) {
    const {
      auth,
      app,
      changePage,
      rsaChangePage,
      i18n: { messages },
      marque: { loginDissmiss },
      auth: { isPaymentCheck, vascoActivated, entitlements: { trading } },
      rmAccess: { RMWarningPrompt },
      alerts: { isAvaloqDown }

    } = this.props;

    const currentPath = this.props.ui.history.currentLocation.pathname;
    const basePath = currentPath.split('/')[1];
    const entitlement = auth.entitlement;
    const moduleEntitlements = auth.entitlements;
    const webfolder = config.webfolder;

    return (
      
      <div ref={this.webNavRef} role="navigation" id="main-app-nav"
        className={
          !loginDissmiss ? 'nav-content-web margin-top-50' : 'nav-content-web'
        }
      >
        <DbText tabIndex={-1} className={'logo-web'}  />
        <SkipMainContent />
        <div role="tablist">
          {entitlement.portfolio && !auth.passwordExpired && (
            <div tabIndex={0} role="tab"
              className={!this.props.payments.disableTabs ? 'nav-text-margin' : 'nav-text-margin disabled'}
              onKeyDown={(e) => this.handleSubmit('dashboard', e)}
              onClick={() => this.handleSubmit('dashboard')}

            >
              <div
                id="Dashboard"
                className={classNames({
                  label: true,
                  inactive: !this.checkActive('dashboard').active,
                })}
              >
                <Portfolio
                  role="presentation"
                  id="dashboardSummary"
                  width={24}
                  height={24}
                  className="nav-icon-margin"
                  color={this.checkActive('dashboard').color}
                />
                {messages['app.common.pageTitle.dashboard']}
              </div>
            </div>
          )}


          {entitlement.portfolio && !auth.passwordExpired && (
            <div tabIndex={0} role="tab"
              className={!this.props.payments.disableTabs ? 'nav-text-margin' : 'nav-text-margin disabled'}
              onKeyDown={(e) => this.handleSubmit('portfolios', e)}
              onClick={() => this.handleSubmit('portfolios')}
            >
              <div
                id="Portfolio"
                className={classNames({
                  label: true,
                  inactive: !this.checkActive('portfolios').active,
                })}
              >
                <PortfolioIcon
                  id="portfolioIcon"
                  width={24}
                  height={24}
                  className="nav-icon-margin"
                  color={this.checkActive('portfolios').color}
                />
                {messages['app.common.pageTitle.assets']}
              </div>
            </div>
          )}

          {entitlement.maturities && !auth.passwordExpired && (
            <div tabIndex={0} role="tab"
              className={!this.props.payments.disableTabs ? 'nav-text-margin' : 'nav-text-margin disabled'}
              onKeyDown={(e) => this.handleSubmit('maturities', e)}
              onClick={() => this.handleSubmit('maturities')}

            >
              <div
                id="Maturities"
                className={classNames({
                  label: true,
                  inactive: !this.checkActive('maturities').active,
                })}
              >
                <MaturitiesIcon
                  id="maturitiesoIcon"
                  width={24}
                  height={24}
                  className="nav-icon-margin"
                  color={this.checkActive('maturities').color}
                />
                {messages['app.common.pageTitle.maturities']}
              </div>
            </div>
          )}

          {entitlement.insights && !auth.passwordExpired && (
            <div tabIndex={0} role="tab"
              className={!this.props.payments.disableTabs ? 'nav-text-margin' : 'nav-text-margin disabled'}
              onClick={() => this.handleSubmit('insights')}
            >
              <div
                id="Insights"
                className={classNames({
                  label: true,
                  inactive: !this.checkActive('insights').active,
                })}
              >
                <InsightsIcon
                  width={24}
                  height={24}
                  className="nav-icon-margin"
                  color={this.checkActive('insights').color}
                />
                {messages['app.common.pageTitle.insights']}
              </div>
            </div>
          )}

          {entitlement.reports && !auth.passwordExpired && (
            <div tabIndex={isAvaloqDown ? -1 : 0} role="tab"
              className={!this.props.payments.disableTabs && !isAvaloqDown ? 'nav-text-margin' : 'nav-text-margin disabled'}
              onKeyDown={(e) => this.handleSubmit('reports', e)}
              onClick={() => this.handleSubmit('reports')}
            >

              <div
                id="Reports"
                className={classNames({
                  label: true,
                  inactive: !this.checkActive('reports').active,
                })}
              >
                <ReportsIcon
                  id="reportsIcon"
                  width={24}
                  height={24}
                  className="nav-icon-margin"
                  color={this.checkActive('reports').color}
                />
                {messages['app.common.pageTitle.reports']}
              </div>
            </div>
          )}

          {
            <div tabIndex={isAvaloqDown ? -1 : 0} role="tab"
              className={!this.props.payments.disableTabs && !isAvaloqDown ? 'nav-text-margin' : 'nav-text-margin disabled'} // WMCE-5862 , Removed disabled Payments tab option in case user don't have entitlement
              onKeyDown={(e) => this.handleSubmit('payments', e)}
              onClick={() => this.handleSubmit('payments')}
            >

              <div
                id="Payments"
                className={classNames({
                  label: true,
                  inactive: !this.checkActive('payments').active,
                })}
              >
                <Transactions
                  width={24}
                  height={24}
                  className="nav-icon-margin"
                  color={this.checkActive('payments').color}
                  role="presentation"
                />
                {messages['app.common.pageTitle.payments']}
              </div>
            </div>
            }

          {moduleEntitlements.transactions && !auth.passwordExpired && (
            <div tabIndex={0} role="tab"
              className={!this.props.payments.disableTabs ? 'nav-text-margin' : 'nav-text-margin disabled'}
              onKeyDown={(e) => this.handleSubmit('transactions', e)}
              onClick={() => this.handleSubmit('transactions')}
            >
              <div
                id="Transactions"
                className={classNames({
                  label: true,
                  inactive: !this.checkActive('transactions').active,
                })}
              >
                <PriceandLiquidity
                  id="transactionsIcon"
                  width={24}
                  height={24}
                  className="nav-icon-margin"
                  color={this.checkActive('transactions').color}
                />
                {messages['app.common.pageTitle.transactions']}
              </div>
            </div>
          )}

          {moduleEntitlements.dataExtracts && !auth.passwordExpired && (

            <div tabIndex={0} role="tab"
              className={!this.props.payments.disableTabs ? 'nav-text-margin' : 'nav-text-margin disabled'}
              onKeyDown={(e) => this.handleSubmit('dataExports', e)}
              onClick={() => this.handleSubmit('dataExports')}
            >
              <div
                id="DataExports"
                className={classNames({
                  label: true,
                  inactive: !this.checkActive('dataExports').active,
                })}
              >
                <Download
                  role="presentation"
                  id="dataExportsIcon"
                  width={24}
                  height={24}
                  className="nav-icon-margin"
                  color={this.checkActive('dataExports').color}
                />
                {messages['app.common.pageTitle.dataExports']}
              </div>
            </div>
          )}
          {/* WMCE-8962 Menu icon replaced with setting*/}
          {/* {vascoActivated && trading && envConfig.envConfig !== EBANKINGWEBLUX && <a
            className={!this.props.payments.disableTabs ? 'nav-text-margin' : 'nav-text-margin disabled'}
            onClick={() => this.handleSubmit('trade-library')}
          >
            <div
              id="trading"
              className={classNames({
                label: true,
                inactive: !this.checkActive('trade-library').active,
              })}
            >
              <TradingPlatform id="dataExportsIcon" width={RIGHT_MENU_ICON_STYLE.width}
                height={RIGHT_MENU_ICON_STYLE.height} color={iconStyle.color}
                className="nav-icon-margin"
                color={this.checkActive('trade-library').color}
              />
              {messages['app.trade']}
            </div>
          </a>} */}
          {!auth.passwordExpired && (
            <div tabIndex={isAvaloqDown ? -1 : 0} role="tab"
              className={!this.props.payments.disableTabs && !isAvaloqDown ? 'nav-text-margin' : 'nav-text-margin disabled'}
              onKeyDown={(e) => this.handleSubmit(CASH_ACCOUNTS_CONSTANTS.CASH_ACCOUNTS, e)}
              onClick={() => this.handleSubmit(CASH_ACCOUNTS_CONSTANTS.CASH_ACCOUNTS)}
            >
              <div
                id="CashAccounts"
                className={classNames({
                  label: true,
                  inactive: !this.checkActive(CASH_ACCOUNTS_CONSTANTS.CASH_ACCOUNTS).active,
                })}
              >
                <IncomeTransactionInformation
                role="presentation"
                  id="cashAccountsIcon"
                  width={24}
                  height={24}
                  className="nav-icon-margin"
                  color={this.checkActive(CASH_ACCOUNTS_CONSTANTS.CASH_ACCOUNTS).color}
                />
                {messages['app.cashAccounts.label.cashAccounts']}
              </div>
            </div>
          )}
        </div>

        <div id="navIcon_maturities_appNav_test" className='nav-icon-group margin-top-5'>
          {!auth.passwordExpired &&
            (
              <span
                className={!this.props.payments.disableTabs ? "nav-icon-group-pass" : 'nav-icon-group-pass disabled'}>
                <span className={'margin-left-20 pointer'} role='button' aria-label={messages['app.settings']}  onKeyDown={(e) => this.onSettingChange(e)} onClick={() => this.onSettingChange()} id="icon_settings_appNav_test" tabIndex="0">
                  {/* WMCE-8962 Menu icon replaced with setting*/}
                  <Gear width={RIGHT_MENU_ICON_STYLE.width} height={RIGHT_MENU_ICON_STYLE.height} color={PALETTE.midGrey} />
                </span>
                <span className={'margin-left-20 pointer'} role='search' aria-label={messages['app.dash.accessibility.link.globalSearch']} onKeyDown={(e) => this.onSearch(e)} onClick={() => this.onSearch()} id="icon_search_appNav_test" tabIndex="0">
                  <Search width={RIGHT_MENU_ICON_STYLE.width} height={RIGHT_MENU_ICON_STYLE.height} color={PALETTE.midGrey} fill={PALETTE.midGrey} />
                </span>
                <span>
                  {entitlement.notification && (
                    <NotificationAlert
                    />
                  )}
                </span>
              </span>
            )
          }

          {entitlement.contract_switch && <span tabIndex={0} id="btn_RM_access_landingPage"
          role='button' aria-label={messages['app.dash.accessibility.link.rmSwitch']}
            className={'margin-left-20 pointer'}
            onKeyDown={(e) => this.showHideRMWarningPrompt(e)}
            onClick={() => this.showHideRMWarningPrompt()}
          >
            <Transform
              width={RIGHT_MENU_ICON_STYLE.width} height={RIGHT_MENU_ICON_STYLE.height} color={PALETTE.midGrey} />
          </span>}
          <span id="btn_logOut_landingPage" tabIndex={0} role='button'
            aria-label={messages['app.auth.logoutConfirm.title']}
            className={'margin-left-20 margin-right-20 pointer logoutPopup'}
            onClick={() => this.onLogout()}
            onKeyDown={(e) => this.onLogout(e)}
          >
            <Logout width={RIGHT_MENU_ICON_STYLE.width} height={RIGHT_MENU_ICON_STYLE.height} color={PALETTE.midGrey} />
          </span>
          <div>
          {this.state.logoutModal && (
              <BlurModal
                visible={this.state.logoutModal}
                onDone={(e) => this.closeBlurModel(e)}
                title={messages['app.common.profile.logOut']}
                className={"model-window-login"}
                // headerChildren={messages['app.common.profile.logOut']}
              >
                <div className="row padding-left-10">
                  <Text tabIndex={0}>{messages['app.common.profile.logOutPrompt']}</Text>
                  <div className="logout-confirm-btns margin-top-10">
                    <div className="column small-3 pad-bottom-0 center">

                      {
                        <Button size='large' fullWidth tertiary loading={!!this.state.loadingFlag} className="btnLogOutFocus"
                          onClick={() => this.state.loadingFlag ? ' ' : this.handleLogoutPressCH()}
                        >{messages['app.common.alert.yes']}</Button>
                      }

                    </div>
                    <div className="column center small-3">
                      <Button size='large' fullWidth testID="logout_popup_no_button" id="logout_popup_no_button"
                        onClick={(e) => this.handleLogoutNo(e)}
                      > {messages['app.common.alert.no']}</Button>
                    </div>
                  </div>
                </div>

              </BlurModal>
            )}
          </div>
        </div>

        {this.state.rmAccessPopup && <BlurModal
          visible
          doneVisible={false}
          backVisible={false}
          title={messages['app.rmAccess.warning']}
          onDone={() => this.showHideRMWarningPrompt()}
          className={"model-window-login"}
        >
          <div className="row padding-left-10">
            <Text>{messages['app.rmAccess.warning.desc']}</Text>
            <div className="logout-confirm-btns margin-top-10">
              <div className="column small-3 pad-bottom-0 center">
                <Button
                  className="btnRmSwitch"
                  size='large'
                  fullWidth
                  tertiary
                  onKeyDown={(e) => this.onSwitchRMSession(e)}
                  onPress={() => this.onSwitchRMSession()} >
                  {messages['app.rmAccess.button.confirm']}
                </Button>
              </div>
              <div className="column center small-3">
                <Button
                  size='large'
                  fullWidth
                  primary
                  onKeyDown={(e) => this.onSwitchRMSession(e)}
                  onPress={() => this.showHideRMWarningPrompt()} >
                  {messages['app.rmAccess.button.cancel']}
                </Button>
              </div>
            </div >
          </div >
        </BlurModal>
        }
      </div >
    );
  }

  NavList(heightValue, widthValue) {
    const {
      auth,
      i18n: { messages },
    } = this.props;

    const entitlement = auth.entitlement;
    const moduleEntitlements = auth.entitlements;

    return (

      <div className={'nav-content'}>
        {entitlement.portfolio && !auth.passwordExpired && (
          <a onClick={() => this.handleSubmit('dashboard')}>
            <div className={'nav-item'}>
              <Portfolio
                id="dashboardSummary"
                height={heightValue}
                width={widthValue}
                color={this.checkActive('dashboard').color}
              />
              <div
                id="Dashboard"
                className={classNames({
                  label: true,
                  inactive: !this.checkActive('dashboard').active,
                })}
              >
                {messages['app.common.pageTitle.dashboard']}
              </div>
            </div>
          </a>
        )}
        {entitlement.portfolio && !auth.passwordExpired && (
          <a onClick={() => this.handleSubmit('portfolios')}>
            <div className={'nav-item'}>
              <PortfolioIcon
                id="portfolioIcon"
                height={heightValue}
                width={widthValue}
                color={this.checkActive('portfolios').color}
              />
              <div
                id="Portfolio"
                className={classNames({
                  label: true,
                  inactive: !this.checkActive('portfolios').active,
                })}
              >
                {messages['app.common.pageTitle.assets']}
              </div>
            </div>
          </a>
        )}

        {entitlement.maturities && !auth.passwordExpired && (
          <a onClick={() => this.handleSubmit('maturities')}>
            <div className={'nav-item'}>
              <MaturitiesIcon
                id="maturitiesoIcon"
                height={heightValue}
                width={widthValue}
                color={this.checkActive('maturities').color}
              />
              <div
                id="Maturities"
                className={classNames({
                  label: true,
                  inactive: !this.checkActive('maturities').active,
                })}
              >
                {messages['app.common.pageTitle.maturities']}
              </div>
            </div>
          </a>
        )}

        {entitlement.insights && !auth.passwordExpired && (
          <a onClick={() => this.handleSubmit('insights')}>
            <div className={'nav-item'}>
              <InsightsIcon
                height={heightValue}
                width={widthValue}
                color={this.checkActive('insights').color}
              />
              <div
                id="Insights"
                className={classNames({
                  label: true,
                  inactive: !this.checkActive('insights').active,
                })}
              >
                {messages['app.common.pageTitle.insights']}
              </div>
            </div>
          </a>
        )}

        {entitlement.reports && !auth.passwordExpired && (
          <a onClick={() => this.handleSubmit('reports')}>
            <div className={'nav-item'}>
              <ReportsIcon
                id="reportsIcon"
                height={heightValue}
                width={widthValue}
                color={this.checkActive('reports').color}
              />
              <div
                id="Reports"
                className={classNames({
                  label: true,
                  inactive: !this.checkActive('reports').active,
                })}
              >
                {messages['app.common.pageTitle.reports']}
              </div>
            </div>
          </a>
        )}

        {moduleEntitlements.dataExtracts && !auth.passwordExpired && (
          <a onClick={() => this.handleSubmit('dataExports')}>
            <div className={'nav-item'}>
              <Download
                id="dataExportsIcon"
                height={heightValue}
                width={widthValue}
                color={this.checkActive('dataExports').color}
              />
              <div
                id="DataExports"
                className={classNames({
                  label: true,
                  inactive: !this.checkActive('dataExports').active,
                })}
              >
                {messages['app.common.pageTitle.dataExports']}
              </div>
            </div>
          </a>
        )}

        {moduleEntitlements.transactions && !auth.passwordExpired && (
          <a onClick={() => this.handleSubmit('transactions')}>
            <div className={'nav-item'}>
              <PriceandLiquidity
                id="transactionsIcon"
                height={heightValue}
                width={widthValue}
                color={this.checkActive('transactions').color}
              />
              <div
                id="Transactions"
                className={classNames({
                  label: true,
                  inactive: !this.checkActive('transactions').active,
                })}
              >
                {messages['app.common.pageTitle.transactions']}
              </div>
            </div>
          </a>
        )}
      </div>
    );
  }

  render() {
    const { i18n: { messages } } = this.props;
    if (this.state.showRedirectModal) {
      return (
        <BlurModal
          visible={true}
          disableOutsideClick
          onDone={this.hideRedirecteModal}
          title={messages['app.manageContactDetails.amendContact.warning']}
          size="large"
          className={"model-window-login"}
        >
          {this.redirectModalContent()}
        </BlurModal>
      );
    }
    return (
      <section className={'app-nav'}>
        <div className={`side-menu hide-for-small-only ${this.props.ais.isBannerVisible ? 'opacityForBanner': null}`}>
          {this.WebNav(35, 35)}
        </div>
        <div className={'footer-menu show-for-small-only'}>
          {this.NavList(30, 30)}
        </div>
      </section>
    );
  }
}

export default createContainer({
  $queries: {
    changePage: { $call: 'ui.history.push' },
    rsaChangePage: { $call: 'rsa.changePage' },
    getOverallMarketAsOfDate: { $call: 'portfolio.getOverallMarketAsOfDate' },
    screen: {
      height: true,
      width: true,
      isSmall: true,
    },
    portfolio: {
      portfolioBPLimit: true,
      genericAssets: {
        positions: {
          setPageOffset: { $set: 'pageOffset' },
        }  
      }
    },
    auth: {
      assetTabSelectedIndex: true,
      setAssetSelectedIndex: { $set: 'assetTabSelectedIndex' },

      entitlement: true,
      onLogout: { $call: 'logout' },
      passwordExpired: true,
      isPaymentCheck: true,
      vascoActivated: true,
      isRMUserGroup: true,
      entitlements: {
        dataExtracts: true,
        transactions: true,
        trading: true,
      }
    },
    app: {
      user: {
        selectedPortfolioData: true,
      },
    },
    i18n: {
      messages: true,
    },
    marque: {
      loginDissmiss: true,
    },
    ui: {
      history: {
        currentLocation: {
          pathname: true,
        },
      },
      state: {
        portfolio: {
          genericAssets: {
             resetSort: { $call: 'resetSort' },
          },
        },
      },
    },
    payments: {
      disableTabs: true,
      isMultiSigApprovalFlow: true,
      cancelTx : { $call: 'cancelTx'},

    },
    rmAccess: {
      RMWarningPrompt: true,
      setRMWarningPrompt: { $set: 'RMWarningPrompt' },
      rmSessionLogout: { $call: 'rmSessionLogout' },
      rmLogout: { $call: 'logout' }
    },
    setInitialPath: { $set: 'ui.component.initialPath' },
    setInitialPathGuid: { $set: 'ui.component.initialPathGuid' },
    hrmw: {
      contactDetailsStatus: true,
      isDataUpdated: true,
      setDataUpdate: { $call: 'setDataUpdate' },
      setDeletedRow: { $set: 'isRowDeleted' },
      setAddedRow: { $set: 'isRowAdded' }
    },
    ais: {
      isBannerVisible: true
    },
    maturities: {
      resetTo7days: { $call: 'resetTo7days'}
    },
    getUserAlerts: { $call: 'alerts.list' },
    alerts: {
      isAvaloqDown: true,
    }
  },
})(AppNav);
// export default AppNav;
